import * as api from './api'
import * as socket from './socket'
import * as storage from './storage'
import mixpanel from './mixpanel'

export { api, socket, storage, mixpanel };



// WEBPACK FOOTER //
// ./src/store/services/index.js